import {BaseWidget} from "../BaseWidget";
import {BaseMuWidget} from "../BaseMuWidget";
import {TicketOverviewCL} from "../generated/TicketOverviewCL";
import {TicketEvent} from "../InvoiceTypes";
import {MuRouter} from "mu-widget/lib/MuRouter";
import {MuWidget} from "mu-widget/lib/MuWidget";
import {TOInvoiceApproving} from "./TOInvoiceApproving";
import {CachedPromise} from "../CachedPromise";
import {BaseRouter} from "../BaseRouter";
import {TOIInvoiceApproving} from "./TOIInvoiceApproving";
import {UiBuSubjectsFilter} from "../dms/UiBuSubjects";
import {Ticket} from "../TicketTypes";
import {changeClassStartsWith} from "../Utils";

export abstract class BaseTO extends BaseMuWidget {
	// @ts-ignore
	profile: {name:string, code:string, id: number};

	public ticketListSize: number = 4;

	public cl: TicketOverviewCL = new TicketOverviewCL();

	protected filter: any = {};

	// @ts-ignore
	protected currentSubProfile: SubProfile;

	protected subprofiles = new CachedPromise(() => this.cl.getSubProfiles(this.profile.id));

	afterIndex() {
		this.setPageTitle(this.profile.name);
	}

	protected htmlNavSubprofiles(btnAdd: boolean = false): string
	{
		return `<div class="display-flex">`
			 + (btnAdd ? '<span class="icon-before-add icon-above a p1" mu="bAdd">Přidat</span>' : '')
			 + `<ul class="bcm-nav-tabs" mu-id="subProfiles">
				<li mu-widget="TOInvoiceApprovingSubProfileItem" mu-template="subProfilesItem"><a mu-id="btn">
					<span mu-id="name"></span>
					<span class="badge" mu-id="count"></span>
				</a></li>
			</ul>
		</div>`;
	}

	protected htmlToolbar(
		btnFilter: boolean = true,
		btnSwitchLayout: boolean = false,
		dateRange: boolean = false,
	): string
	{
		return `<div class="toolbar" mu="toolbar">`
				+ (btnSwitchLayout ? '<span class="btn btn-icon icon-before-switch-columns" mu-id="bSwitchLayout"></span>' : '')
				+ `<span class="btn btn-link icon-before-reload" mu-id="bReload">Obnovit</span>`
				+ (dateRange ? ' od <input type="date" mu="cDateFrom"> do <input type="date" mu="cDateTo">' : '')
				+ (btnFilter
					? '<span class="btn btn-link icon-before-filter" mu-id="bFilter">Filtrovat <span mu-id="filterCount" class="badge"></span></span>'
					: ''
				) + `<span class="btn btn-link icon-before-erase" mu-id="bFilterErase">Zrušit filtr</span>
				<input type="search" class="form-control flex-grow-1" mu-id="cFulltext" mu-keybind="Enter:bFulltextSearch" />
				<span class="btn btn-link icon-before-search" mu-id="bFulltextSearch">Vyhledat</span>
			</div>`;
	}

	protected setupRouter() {
		this.router = new BaseRouter();
		this.router.pathPrefix = "/ticket/overview/" + this.profile.code;

		this.router.persistentKeys = [ "subprofile" ];

		const findSubProfile = async(id: string) => (await this.subprofiles.fetch()).find((sp: SubProfile) => sp.id === id);

		this.router.addRoute('ticket', '/<subprofile>/<ticketId>',
			async(rc) => {
				this.activateSubProfile(await findSubProfile(rc.parameters.subprofile as string), false)
				this.loadTicket(parseInt(rc.parameters.ticketId as string));
			});

		this.router.addRoute('overview', '/<subprofile>',
			async(rc) =>
				this.activateSubProfile(await findSubProfile(rc.parameters.subprofile as string), true)
		);

		this.router.addRoute('root', '',
			async (rc) => this.activateSubProfile((await this.subprofiles.fetch())[0], true));

	}

	setupSubProfiles(subProfiles: any[]) {
		for(const subProfile of subProfiles) {
			this.muWidgetFromTemplate(
				"subProfilesItem",
				"subProfiles",
				{ ...subProfile, subProfile: subProfile }
			)
		}
	}

	public abstract loadTicket(id: number|string, metadata?: any): Promise<any>;

	private currentTicket: Ticket|null = null;

	protected overviewLayoutPrefix: string = '';

	activateSubProfile(subProfile: SubProfile, loadFirst: boolean) {
		this.currentSubProfile = subProfile;
		this.muGetChildWidgets<TOInvoiceApprovingSubProfileItem>("subProfiles").forEach(iw => iw.setActiveIf(subProfile.id));
		//@ts-ignore
		this.ui.overviewItems.className = `layout-${this.overviewLayoutPrefix}default layout-${this.overviewLayoutPrefix}${subProfile.id}`;
		// this.router!.pushUpdate('overview', { subprofile: subProfile.id });
		this.router!.updatePersistent({ subprofile: subProfile.id }, true);
		this.loadList(loadFirst);

		if (this.ui.sidePanel) {
			const ticketListSize = subProfile.ticketListSize ?? this.ticketListSize;
			changeClassStartsWith(this.ui.sidePanel.classList, 'col-sm-', ticketListSize.toString())
			changeClassStartsWith(this.ui.ticketDetail.classList, 'col-sm-', (12 - ticketListSize).toString())
		}
	}

	protected abstract loadList(loadNext?: boolean): Promise<any>;

	protected markSelectedTicket() {
		const id = this.currentTicket ? this.currentTicket.id : null;
		this.muGetChildWidgets<TOIInvoiceApproving>("overviewItems").forEach(iw => iw.setActiveIf(id));
	}

	bFilterErase_click() {
		this.ui.cFulltext.value = "";
		this.setFilter({});
	}

	private setFilter(filter: Record<string, any>) {
		this.filter = filter;
		const activeFieldsCount = UiBuSubjectsFilter.filtredFields(filter).length;
		this.ui.filterCount.innerText = activeFieldsCount > 0 ? activeFieldsCount.toString() : "";

		this.loadList();
	}

	public patchFilter(filter: Record<string, any>) {
		this.setFilter({ ...this.filter, ...filter });
	}

	bFulltextSearch_click() {
		this.loadList();
	}

	bReload_click() {
		this.loadList();
	}

}

export class TOInvoiceApprovingSubProfileItem extends MuWidget {

	public name: string = "";

	public id: string = "";

	// @ts-ignore
	public subProfile: SubProfile;

	// @ts-ignore
	public muParent: TOInvoiceApproving;

	afterIndex() {
		this.ui.name.innerText = this.name;
		// @ts-ignore
		this.muParent.router.prepareAnchor(this.ui.btn, "overview", { subprofile: this.subProfile.id });
	}

	/* btn_click() {
		this.muParent.activateSubProfile(this.subProfile);
	} */

	setActiveIf(id: string) {
		this.container.classList.toggle("active", id === this.id)
	}

	setCount(count: any) {
		this.ui.count.innerText = count || '';
	}
}


type StateGroup = {
	color: string;
	name: string,
	states: string[],
}

export type SubProfile = {
	// defaultFilter: [],
	ticketListSize?: number;
	stateGroups: StateGroup[];
	states: State[];
	defaultStates:string[],
	layout: "calendar"|"list"|string;
	useComments: boolean | null;
	hideTicketSaveButtons: boolean;
	formOptions: any;
	accountingDocumentTypePrefix: string;
	totalCountLabel: string,
	// viewCondition: [],
	groupByAccountingDocumentType: boolean,
	groupByTicketType: boolean,
	groupByPqm: false|"master"|"item",
	id: string,
	name: string,
	afterSaveTicket: AfterSave,
	afterSaveInvoice: AfterSave,
	hideTicketButtons: boolean,
	readonlyForm: boolean|string,
	events: Record<TicketEvent, TicketAction>,
	subjectInTitle: boolean|null,
	ticketStateInTitle: boolean,
}

export type State = {
	code: string;
	name: string,
	color: string|null,
	id: number
}

export type TicketEventRes = {
	action?: TicketAction
};

export type TicketAction = "reloadNext"|"reloadSame";

export type AfterSave = "nextTicket"|"sameTicket";

export type TicketMetadata = {
	id: number,
	evidenceUid: string,
	summary: string,
	buSubjectName: string|null,
	accountDocumentTypeId: number|null,
	useComments: boolean,
	stateName: string,
};